import { useEffect } from 'react';

import { useAuthStore } from '~/stores/use-auth/store/authStore';
import { useNotifications } from '~/stores/use-notifications/useNotifications';
import { useChat } from '~/views/alfred/research/use-chat/useChat';
import { usePortfolio } from '~/views/settings/portfolio-view/use-portfolio/usePortfolio';

const faviconLinks = {
  default: '/app/static/images/brand/favicon.svg',
  notification: '/app/static/images/brand/favicon-notification.svg',
};

export const useNotificationsListener = () => {
  const token = useAuthStore(s => s.token);
  const handlePortfolioWebsocketResponse = usePortfolio(
    state => state.handlePortfolioWebsocketResponse
  );

  const { subscribeToMessageOfType, unsubscribe } = useNotifications(state => ({
    subscribeToMessageOfType: state.subscribeToMessageOfType,
    unsubscribe: state.unsubscribe,
  }));
  const { getConversationStates, markConversationReadStatus } = useChat(
    state => ({
      getConversationStates: state.getConversationStates,
      markConversationReadStatus: state.markConversationReadStatus,
    })
  );

  const toggleFavicon = (key: keyof typeof faviconLinks) => {
    const faviconElement = document.querySelector("link[rel*='icon']");
    faviconElement?.setAttribute('href', faviconLinks[key]);
  };

  useEffect(() => {
    return useChat.subscribe(state => {
      const completeUnreadConversationsCount =
        state.getCompleteUnreadConversations().length;

      toggleFavicon(
        completeUnreadConversationsCount ? 'notification' : 'default'
      );
    });
  }, []);

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    subscribeToMessageOfType('conversation', async response => {
      await getConversationStates({
        conversationId: response.metadata.conversation_id,
        taskId: response.metadata.request_id,
      });

      if (response.event.action !== 'request.fail') {
        markConversationReadStatus(
          response.metadata.conversation_id,
          response.event.action === 'request.cancel'
        );
      }
    });

    subscribeToMessageOfType('portfolio', async response => {
      handlePortfolioWebsocketResponse(response);
    });

    return unsubscribe;
  }, [token]);
};
